// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "container-3LBFc";
var _3 = "content-1HbPj";
var _4 = "option__price-1ZVbK";
export { _1 as "__esModule", _2 as "container", _3 as "content", _4 as "option__price" }
export default { "__esModule": _1, "container": _2, "content": _3, "option__price": _4 }
